export default {
  sponsors: 'hasMany',
  require_cc: 'boolean',
  event_tracking: 'array',
  is_live: 'boolean',
  show_date: 'boolean',
  show_start_time: 'boolean',
  show_end_date: 'boolean',
  show_end_time: 'boolean',
  show_address: 'boolean',
  live_settings: {
    eid: 'number',
    id: 'number',
    is_live: 'boolean',
    live_mode: 'boolean',
    show_engagements: 'boolean',
    show_room_count: 'boolean',
    show_chat: 'boolean',
    compact_buttons: 'boolean',
    replay_mode: 'boolean'
  }
}



// WEBPACK FOOTER //
// ./src/store/models/event.js